// Localization - common resolution objects for design-system
export const CANCEL_RES = { res: "Cancel" };
export const CLEAR_RES = { res: "Clear" };
export const DECREMENT_RES = { res: "FormFieldDecrement" };
export const GO_TO_DIALOG_RES = { res: "GoToDialog" };
export const INCREMENT_RES = { res: "FormFieldIncrement" };
export const INVALID_RES = { res: "Invalid" };
export const INVALID_NUMBER_RES = { res: "ValidateNotValid" };
export const OK_RES = { res: "OK" };
export const OPEN_RES = { res: "Open" };
export const REMOVE_RES = { res: "Remove" };
export const REQUIRED_RES = { res: "RequiredValue" };
export const SAVE_RES = { res: "Save" };
export const SAVE_GO_RES = { res: "Save_Go" };
export const SAVE_NEW_RES = { res: "Save_New" };
export const OUT_OF_RANGE_RES = { res: "FormFieldOutOfRange" };
export const NEGATIVE_NOT_ALLOWED_RES = { res: "FormFieldNegativeNotAllowed" };

// common strings
export const EMPTY_READONLY = "FormFieldEmptyReadOnly";
